import flowSensorApi from '@/api/config/flowSensorApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

function useGetDetailInput(interfaceId: number) {
  return useQuery({
    // Keyed by interface: the decoders belong to one controller, and without
    // this a second interface reads back the first one's list.
    queryKey: [queryKeys.ioOptions, interfaceId],
    queryFn: async () => {
      const { data } = await flowSensorApi.getDetailIO(interfaceId)

      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
  })
}

export default useGetDetailInput
